import React from "react";

class DexAddress extends React.Component {
  render() {
    return (
      <div className="mail">
        <h2 className="mail__title">Хотите работать эффективно?</h2>
        <a
          className="mail__btn"
          href="https://kb.survey-studio.com/start/cati/2002/"
        >
          Подключить DEX
        </a>
        <div className="mail__envelope">
          <i className="fa fa-envelope-o"></i>
          <a
            className="mail__envelope-link"
            href="mailto:info@survey-studio.com"
          >
            info@survey-studio.com
          </a>
        </div>
      </div>
    );
  }
}

export default DexAddress;



// WEBPACK FOOTER //
// ./src/Components/DialerExpress/DexAddress.js